import React, { useState, useEffect, useRef } from 'react';
import { Col } from 'react-bootstrap';
import Modal from 'v3/components/Modal';
import Button from 'v3/components/Button';
import Text from 'v3/components/Text';
import VehicleRegisterOcr from '../VehicleRegisterOcr'
import ManualRegisterVehicle from '../ManualRegisterVehicle'

function RegisterVehicle({ isOpen, onClose, sendResponse }) {

  const manualRef = useRef(null);
  const ocrRef = useRef(null);

  const [manualRegister, setManualRegister] = useState(false)

  const [frontImageCrlv, setFrontImageCrlv] = useState([]);
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  async function handleSave() {
    if (manualRegister) {
      await manualRef.current?.save();
    } else {
      await ocrRef.current?.save();
    }
  }

  const handleClose = () => {
    onClose();
    setData({});
    setFrontImageCrlv([]);
    setErrors({});
    setManualRegister(false);
  }

  useEffect(() => {
    setData({});
    setFrontImageCrlv([]);
    setErrors({});
  }, [manualRegister])

  return (
    <>
      <Modal
        show={isOpen}
        handleClose={handleClose}
        heading={
          <div
            style={{
              alignItems: 'center',
              display: 'flex',
              gap: 16,
              justifyContent: 'space-between',
              paddingRight: 32,
              width: '100%',
            }}
          >
            <Text type="header" color="dark" weight="500">
              Cadastrar veículo
            </Text>
            <Button
              className="py-2"
              onClick={() => setManualRegister(!manualRegister)}
            >
              <Text weight="500" type="regular">
                {!manualRegister ? 'Cadastro manual' : 'Importar veículo'}
              </Text>
            </Button>
          </div>
        }
        body={
          <>
            {
              manualRegister ? (
                <ManualRegisterVehicle
                  ref={manualRef}
                  data={data}
                  setData={setData}
                  handleClose={handleClose}
                  loading={loading}
                  setLoading={setLoading}
                  sendResponse={sendResponse}
                  setErrors={setErrors}
                  errors={errors}
                />
              ) : (
                <VehicleRegisterOcr
                  ref={ocrRef}
                  data={data}
                  setData={setData}
                  handleClose={handleClose}
                  setSaveLoading={setLoading}
                  saveLoading={loading}
                  setErrors={setErrors}
                  errors={errors}
                  sendResponse={sendResponse}
                  setFrontImageCrlv={setFrontImageCrlv}
                  frontImageCrlv={frontImageCrlv}
                />
              )
            }
          </>
        }
        footer={
          <Col
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 8,
              marginTop: 16,
              marginBottom: 32,
            }}
          >
            <Button
              variant="secondary"
              onClick={handleClose}
              loading={loading}
            >
              <Text color="dark" type="regular">
                Voltar
              </Text>
            </Button>
            <Button
              variant="success"
              onClick={handleSave}
              loading={loading}
            >
              <Text weight={500} color="white" type="regular">
                Salvar
              </Text>
            </Button>
          </Col>
        }
      />
    </>
  );
}

export default RegisterVehicle;
